import React, { useState, useRef } from "react";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import styles from "./Heart.module.css";
import { cookies } from "../../axios";
import CustomModal from "../reusablemodal/CustomModal";

const getStyledRating = (isWishlisted) =>
  styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: isWishlisted ? "#ff3d47" : "#fff",
      // stroke: "#ff3d47",
      // strokeWidth: 1.5,
    },
    "& .MuiRating-iconEmpty": {
      color: "#ff3d47",
      // filter: "drop-shadow(0 0 2px rgba(255, 255, 255, 0.7))",
    },
    // "& .MuiRating-iconHover": {
    //   color: "#ff3d47",
    //   stroke: "#ff3d47",
    //   strokeWidth: 1.5,
    // },
  });

const Heart = ({ value, onClick }) => {
  const [miniHearts, setMiniHearts] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false); // ✅ for modal state
  const heartRef = useRef(null);
  const StyledRating = getStyledRating(value);

  const triggerMiniHearts = () => {
    if (!heartRef.current) return;

    const rect = heartRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // create 15 small hearts spreading across screen
    const hearts = Array.from({ length: 15 }).map(() => {
      const angle = Math.random() * 2 * Math.PI; // random direction
      const distance = 100 + Math.random() * 200; // random distance
      const offsetX = Math.cos(angle) * distance;
      const offsetY = Math.sin(angle) * distance;

      return {
        id: Math.random().toString(36).substr(2, 9),
        top: centerY,
        left: centerX,
        offsetX,
        offsetY,
      };
    });

    setMiniHearts((prev) => [...prev, ...hearts]);

    setTimeout(() => {
      setMiniHearts((prev) =>
        prev.filter((h) => !hearts.some((nh) => nh.id === h.id))
      );
    }, 1200);
  };

  const getRandomInt = (min, max) => Math.random() * (max - min) + min;
  const handleModalClose = () => {
    setShowLoginModal(false);
    window.location.href = "/login"; // ✅ redirect to login
  };
  const handleWishlistClick = (e) => {
    e.stopPropagation();

    const hearts = [];
    const count = Math.floor(getRandomInt(15, 20)); // more hearts for better spread
    for (let i = 0; i < count; i++) {
      hearts.push({
        id: Math.random().toString(36).substr(2, 9),
        top: `${Math.floor(getRandomInt(5, 75))}vh`, // random vertical position on screen
        left: `${Math.floor(getRandomInt(5, 75))}vw`, // random horizontal position on screen
      });
    }
    setMiniHearts(hearts);
    setTimeout(() => setMiniHearts([]), 1200);
  };

  // const handleClick = (e) => {
  //   e.stopPropagation();

  //   if (!value) {
  //     // Only trigger mini hearts when favoriting
  //     triggerMiniHearts();
  //     handleWishlistClick(e);
  //   }

  //   if (onClick) onClick(e);
  // };
  const handleClick = (e) => {
    e.stopPropagation();

    // ✅ Check if user exists in cookies
    const userDetails = cookies.get("userDetails") || null;
    const user_id = userDetails?.user_id;

    if (!user_id) {
      // No user logged in → show modal
      setShowLoginModal(true);
      return;
    }

    // ✅ If user logged in → proceed with animation
    if (!value) {
      triggerMiniHearts();
      handleWishlistClick(e);
    }

    if (onClick) onClick(e);
  };
  return (
    <div className={styles.heartWrapper} ref={heartRef} onClick={handleClick}>
      <StyledRating
        name="customized-heart"
        value={value ? 1 : 0}
        max={1}
        readOnly
        icon={<FavoriteIcon fontSize="inherit" />}
        emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
      />

      {/* Mini Hearts */}
      {miniHearts.map((heart) => (
        <svg
          key={heart.id}
          viewBox="0 0 24 22"
          className={styles.subHeart}
          style={{ top: heart.top, left: heart.left }}
        >
          <path
            d="M11.0661 2.81728L11.6026 3.45246L12.1391 2.81728C13.2867 1.45859 15.0479 0.600098 16.8697 0.600098C20.0815 0.600098 22.6051 3.13599 22.6051 6.38807C22.6051 8.38789 21.72 10.2564 20.0229 12.3496C18.3175 14.4529 15.8645 16.6977 12.8407 19.4622L12.826 19.4756L12.8249 19.4766L11.6008 20.6001L10.3798 19.4879L10.3783 19.4866L10.3336 19.4457C7.31862 16.6834 4.87347 14.4409 3.17365 12.3404C1.4821 10.25 0.600098 8.38442 0.600098 6.38807C0.600098 3.13599 3.12361 0.600098 6.33544 0.600098C8.15729 0.600098 9.91845 1.45859 11.0661 2.81728Z"
            fill="#ff4081"
            stroke="#000000ff"
            strokeWidth="2"
          />
        </svg>
      ))}
      {/* ✅ Login Modal Popup */}
      {showLoginModal && (
        <CustomModal
          show={true}
          handleClose={null}
          title="Login Required"
          secondaryButtonLable={null}
          primaryButtonLable="OK"
          renderModalContent="To add this temple to your favorite list, please log in. Begin your divine journey by saving the temples closest to your heart."
          secondaryClick={null}
          primaryClick={handleModalClose}
          backdrop="static"
          keyboard={false}
        />
      )}
    </div>
  );
};

export default Heart;
